import React from 'react';
import { Popconfirm , Switch } from 'antd';

class ActiveToggle extends React.Component{

	render(){
		return (
			<div>
				<Popconfirm 
					title="Are you sure you want to deactivate this promo? This action is not reversible."
					visible={this.state.popConfirm}
					onConfirm={this.confirm}
					onCancel={this.cancel}
					okText="Yes"
					cancelText="No"						
				/>
				<Switch checked={this.props.active} onChange={this.togglePopConfirm} />
			</div>
		)
	}

	state = {
		popConfirm: false
	}

	cancel = () => {
		this.setState({
			popConfirm: false
		})
	}

	confirm = () => {
		this.setState({
			popConfirm: false
		})

		this.props.deActivatePromo()
	}

	togglePopConfirm = () => {
		this.setState({
			popConfirm: true
		})
	}

}

export default ActiveToggle;


// WEBPACK FOOTER //
// ./src/components/promo/payment/active-toggle.js